document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("header");

  if (!header) return;

  function updateHeaderOffset() {
    const announcementBar = document.querySelector(
      ".futureblink-announcement-bar.top-push-scroll"
    );

    const announcementHeight =
      announcementBar && announcementBar.offsetHeight > 0
        ? announcementBar.offsetHeight
        : 0;

    header.style.top = `${announcementHeight}px`;

    return !!announcementBar;
  }

  // Initial run
  const foundInitially = updateHeaderOffset();

  const observer = new MutationObserver(() => {
    const found = updateHeaderOffset();

    // Stop observing once bar is found
    if (found) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  // Destroy observer after 5s if no announcement bar found
  if (!foundInitially) {
    setTimeout(() => {
      observer.disconnect();
    }, 5000);
  }

  window.addEventListener("resize", updateHeaderOffset);
});